import { ModalWrapper } from 'src/components/ModalWrapper';
import { EventShopModalContainer } from './components/ShopModalContainer';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Buttons/Button';
import { useModalContext } from 'src/hooks/useModalContext';
import { EventShopModalProps } from './types';
import { useScrollToHowToEarn } from './hooks/useScrollToHowToEarn';
import { BuyMoney } from 'src/pages/EventShop/AuthorizedEventShop/components/BuyMoney';

export const NoCoinsForMoneyEventModal = () => {
  const { closeModal, openModal, modalProps } = useModalContext<EventShopModalProps>();
  const { t } = useTranslation();
  const { handleToHowToEarn } = useScrollToHowToEarn();
  const handleOpenDepositModal = () => {
    closeModal();
    openModal('DEPOSIT');
  };

  return (
    <ModalWrapper showCross={false} isTransparentBg>
      <EventShopModalContainer title="christmasShop.noCoins" text="christmasShop.youDont">
        <div className="flex flex-col mb-[50px]">
          <BuyMoney item={modalProps?.item} />
          <Button className="w-[165px] self-center" onClick={handleOpenDepositModal}>
            {t('christmasShop.deposit')}
          </Button>
          <button
            className="text-base underline text-center pt-5 text-sp_text font-bold cursor-pointer"
            onClick={handleToHowToEarn}>
            {t('christmasShop.howToEarn')}
          </button>
        </div>
      </EventShopModalContainer>
    </ModalWrapper>
  );
};
